import { useCallback, useEffect, useRef, useState } from "react";
import { getSpokeRoutesCatalog } from "@services/api";
import { notifyError } from "@components/ds/notify";
import { USE_FIXTURES } from "../constants";
import mockRoutesCatalog from "../__fixtures__/mockSpokeRoutesCatalog.json";

// Loads the full route catalog at this CP/spoke for the new
// RoutePickerSheet. Backed by /leader/db-manage-web-v2/scan-sort/routes —
// returns [{ route_id, route_name, locality, user_count, crate_count }].
//
// Distinct from the legacy /leader/dbs-v2/routes-list which the
// CpDeliveryRoutes screen still uses (no counts).

const useRouteCatalog = ({ enabled = true } = {}) => {
  const [routes, setRoutes] = useState([]);
  const [loading, setLoading] = useState(false);
  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const reload = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    if (USE_FIXTURES) {
      const list = Array.isArray(mockRoutesCatalog?.data)
        ? mockRoutesCatalog.data
        : [];
      if (isMounted.current) {
        setRoutes(list);
        setLoading(false);
      }
      return;
    }
    try {
      const res = await getSpokeRoutesCatalog();
      const list = res?.data?.data || res?.data || [];
      if (isMounted.current) {
        setRoutes(Array.isArray(list) ? list : []);
      }
    } catch (e) {
      const msg =
        e?.response?.data?.error ||
        e?.response?.data?.message ||
        e?.message ||
        "Failed to load routes";
      notifyError(msg);
      if (isMounted.current) setRoutes([]);
    } finally {
      if (isMounted.current) setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    if (enabled) reload();
  }, [enabled, reload]);

  return { routes, loading, reload };
};

export default useRouteCatalog;
